import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import general_data from './data/general.json';

const Header = ( {children} ) => {
    const [isScrolled, setIsScrolled] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (<>
        <div className={`header-bar w-full text-900 ${isScrolled ? 'static lg:fixed' : ''}`}>
            <div className={`flex flex-column gap-3 md:gap-0 md:flex-row m-auto w-full pl-3 pr-3 pt-4 pb-4 md:${isScrolled ? 'w-7' : 'w-9'}`}>
                <div className='flex-1 flex justify-content-center md:flex-0 md:justify-content-start'>
                    <div className={`text-3xl coptic-font ${/*isScrolled ? 'block' : 'hidden'*/''}`} style={{color:'#2a4586'}}>
                        <img src='panasea_logo.png' alt='Panasea' style={{height: '2.5rem', width: 'auto', paddingTop: '0.5rem'}} />
                        {/*Panasea*/}
                    </div>
                    {/*<img src='JanaWEBLOGO.png' alt='Jana Pelikan' style={{height: '4rem', width: 'auto'}} />*/}
                </div>
                <div className='flex-1 flex-wrap lg:flex-nowrap justify-content-center md:justify-content-end flex'>
                    {children}
                    <Button label='Home' style={{color: '#301b0d'}} className='p-button-text text-lg mr-2' /*style={{backgroundColor:'rgba(202, 140, 53, 0.1)'}}*/ onClick={() => navigate('/')} />
                    <Button label='Merch' style={{color: '#301b0d'}} className='p-button-text text-lg mr-2' /*style={{backgroundColor:'rgba(202, 140, 53, 0.1)'}}*/ onClick={() => navigate('/merch')} />
                    <Button label='Live' style={{color: '#301b0d'}} className='p-button-text text-lg mr-2' /*style={{backgroundColor:'rgba(202, 140, 53, 0.1)'}}*/ onClick={() => navigate('/live')} />
                    <Button label='Music' style={{color: '#301b0d'}} className='p-button-text text-lg mr-2' /*style={{backgroundColor:'rgba(202, 140, 53, 0.1)'}}*/ onClick={() => navigate('/music')} />
                    <Button label='Contact' style={{color: '#301b0d'}} className='p-button-text text-lg mr-2' /*style={{backgroundColor:'rgba(202, 140, 53, 0.1)'}}*/ onClick={() => navigate('/contact')} />
                </div>
            </div>
        </div>
        <div className={`header-focus-bar w-full text-900`}>
            <div className={`flex flex-column gap-3 md:gap-0 md:flex-row m-auto w-full pl-3 pr-3 pt-2 pb-2 md:w-9`}>
                <div className='flex-1 flex justify-content-center md:flex-0 md:justify-content-center text-lg' style={{color: "#f0eee5"}}>
                    <ReactMarkdown>{general_data.header_text}</ReactMarkdown>
                </div>
            </div>
        </div>
    </>);
};

export default Header;